import * as PIXI from 'pixi.js';

export default class SpriteTree extends PIXI.SimpleRope
{
    constructor(texture, points)
    {
        super(texture, points);

        //this.points = points;

       // this.build();
    }
}
